import { useQuery } from 'react-query';
import axios from 'axios';
import { MonitorQueueAPI } from '../../constants/API';
import { getMonitorToken, queueScreenHeaders } from '../../constants/HeadersAPI';
import { parseMonitorResponse } from '../../utils/QueuePage/parseMonitorResponse';

export type QueueHeadersRespType = {
  id: number;
  title: string;
  subTitle: string;
};

export const useGetQueueHeaders = () => {
  const {
    data: queueHeadersResp,
    isFetching: isLoadingQueueHeaders,
    isSuccess: isQueueHeadersRecieved
  } = useQuery(
    ['QueueHeaders', getMonitorToken()],
    async () => {
      const { data } = await axios.get(
        MonitorQueueAPI.getQueueHeaders,
        queueScreenHeaders()
      );
      return parseMonitorResponse<QueueHeadersRespType>(data);
    },
    {
      isDataEqual: (prev, next) =>
        prev?.id === next?.id &&
        prev?.title === next?.title &&
        prev?.subTitle === next?.subTitle,
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      staleTime: 15000,
      refetchOnWindowFocus: false
    }
  );

  return { queueHeadersResp, isLoadingQueueHeaders, isQueueHeadersRecieved };
};
